<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="lg"
      ok-only
      :ok-title="$t('save')"
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="onSubmit"
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
        <span v-if="isUpdated">{{ form.name }}</span>
      </template>
      <b-form>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Username')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Username')"
                vid="username"
                rules="required"
              >
                <b-form-input
                  id="username"
                  v-model="form.username"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Username')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Name')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Name')"
                vid="name"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="form.name"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Mobile')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Mobile')"
                vid="mobile"
                rules="required"
              >
                <b-form-input
                  id="mobile"
                  v-model="form.mobile"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Mobile')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Email')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Email')"
                vid="email"
              >
                <b-form-input
                  id="email"
                  v-model="form.email"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Email')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Password')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('password')"
                vid="password"
              >
                <b-form-input
                  id="password"
                  v-model="form.password"
                  type="password"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Password')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Source')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Source')"
                vid="source"
                rules="required"
              >
                <b-form-input
                  id="source"
                  v-model="form.source"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Source')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Roles')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Roles')"
                vid="roles_id"
                rules="required"
              >
                <v-select
                  v-model="form.roles_id"
                  :options="additionalData.roles"
                  :clearable="false"
                  multiple
                  label="name"
                  :reduce="_role => _role.id"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Status')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Status')"
                vid="status"
                rules="required"
              >
                <v-select
                  v-model="form.status"
                  :options="additionalData.statuses"
                  :clearable="false"
                  :reduce="_status => _status.key"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Affiliate status')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Affiliate status')"
                vid="affiliate_status"
                rules="required"
              >
                <b-form-checkbox
                  v-model="form.affiliate_status"
                  value="1"
                  unchecked-value="0"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Affiliate percent')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Affiliate percent')"
                vid="affiliate_percent"
                rules="required"
              >
                <b-form-input
                  id="affiliate_percent"
                  v-model="form.affiliate_percent"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Affiliate percent')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Bank account owner')"
              label-for="bank_account_owner"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Bank account owner')"
                vid="bank_account_owner"
              >
                <b-form-input
                  v-model="form.bank_account_owner"
                  :placeholder="$t('Bank account owner')"
                  name="bank_account_owner"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Bank account number')"
              label-for="bank_account_number"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Bank account number')"
                vid="bank_account_number"
              >
                <b-form-input
                  v-model="form.bank_account_number"
                  :placeholder="$t('Bank account number')"
                  name="bank_account_number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Bank account card number')"
              label-for="bank_account_card_number"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Bank account card number')"
                vid="bank_account_card_number"
              >
                <b-form-input
                  v-model="form.bank_account_card_number"
                  :placeholder="$t('Bank account card number')"
                  name="bank_account_card_number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Bank account sheba number')"
              label-for="bank_account_sheba_number"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Bank account sheba number')"
                vid="bank_account_sheba_number"
              >
                <b-form-input
                  v-model="form.bank_account_sheba_number"
                  :placeholder="$t('Bank account sheba number')"
                  name="bank_account_sheba_number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ $t("save") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../../common/mixins/form'

export default {
  name: 'UsersEditModal',
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'users',
      modalName: 'modal-users-edit',
      useRouteName: true,
      createAbleFields: [
        'username',
        'name',
        'mobile',
        'email',
        'password',
        'affiliate_status',
        'affiliate_percent',
        'status',
        'source',
        'roles_id',
        'bank_account_owner',
        'bank_account_number',
        'bank_account_card_number',
        'bank_account_sheba_number',
      ],
    }
  },
}
</script>

<style scoped>

</style>
